var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.showOnlyIcon)?_c('span',[_vm._v(_vm._s(_vm.content))]):_vm._e(),_c('button',{staticClass:"btn_copy_content",on:{"click":function($event){return _vm.handleCopyContent($event, _vm.content)}}},[_c('IconCopyOutlined')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }